import React from 'react';
import { Box, Typography, Paper, IconButton, List, ListItem, Divider } from '@mui/material';
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';

interface ExchangeRateEntry {
    date: string;
    dayLabel?: string;
    rate: string;
}

interface ExchangeRateHistoryProps {
    title?: string;
    entries: ExchangeRateEntry[];
    onCalendarClick?: () => void;
}

const ExchangeRateHistory: React.FC<ExchangeRateHistoryProps> = ({
    title = 'Histórico del tipo de cambio USD/BS.S',
    entries = [],
    onCalendarClick = () => { }
}) => {
    return (
        <Paper
            elevation={0}
            sx={{
                borderRadius: 2,
                border: '1px solid #e0e0e0',
                overflow: 'hidden',
                width: '100%'
            }}
        >
            <Box
                sx={{
                    p: 3,
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                }}
            >
                <Typography variant="h6" component="h2" fontWeight="500">
                    {title}
                </Typography>
                <IconButton onClick={onCalendarClick} color="default" size="small">
                    <CalendarTodayOutlinedIcon />
                </IconButton>
            </Box>

            <List sx={{ width: '100%', p: 0 }}>
                {entries.map((entry, index) => (
                    <React.Fragment key={index}>
                        <ListItem
                            sx={{
                                py: 2,
                                px: 3,
                                display: 'block',
                                bgcolor: 'background.paper',
                                borderTop: index > 0 ? '1px solid #f0f0f0' : 'none'
                            }}
                        >
                            <Typography variant="subtitle1" fontWeight="500" sx={{ mb: 0.5 }}>
                                {entry.date}
                            </Typography>

                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <Typography variant="body2" color="text.secondary">
                                    {entry.dayLabel || "Cuota del día"}
                                </Typography>

                                <Typography variant="h6" fontWeight="600">
                                    {entry.rate}
                                </Typography>
                            </Box>
                        </ListItem>
                    </React.Fragment>
                ))}
            </List>
        </Paper>
    );
};

export default ExchangeRateHistory;